import React, { useState, useRef, useEffect } from 'react';
import './RoyalSalute.css';

import productImage1 from '../images/item001_1.jpg';
import productImage2 from '../images/item001_2.jpg';
import productImage3 from '../images/item001_3.jpg';
import leftArrow from '../images/arrowl.png'; // Your custom left arrow image
import rightArrow from '../images/arrowr.png'; // Your custom right arrow image
import bt_playstone from '../images/p-d-n.png';
import bt_applesotre from '../images/ap-d-n.png';

const productImages = [productImage1, productImage2, productImage3];


const DigitalConfirmRoyalSalute2Component = () => {
  const [imageIndex, setImageIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const fullTextRef = useRef<HTMLParagraphElement>(null);

  const handleNextImage = () => {
    setImageIndex((prevIndex) => (prevIndex + 1) % productImages.length);
  };

  const handlePrevImage = () => {
    setImageIndex((prevIndex) => (prevIndex - 1 + productImages.length) % productImages.length);
  };

  const descriptionText = `Royal Salute 55 Year Old เป็นหนึ่งในวิสกี้ที่เก่าแก่ที่สุดในประวัติศาสตร์ของ Royal Salute

  เป็นรุ่นหายากที่ผลิตเพียง 85 ขวดเท่านั้น บรรจุขวดในแบบ Cask Strength ทำให้สัมผัสได้ถึงความล้ำลึกและเป็นเอกลักษณ์เฉพาะตัว  
  Royal Salute 55 Year Old นี้แสดงให้เห็นถึงสุดยอดฝีมือในการผลิตวิสกี้ และอิทธิพลอันยิ่งใหญ่ของธรรมชาติ รวมทั้งความอดทนในการปรุงวิสกี้ที่มีอายุไม่ธรรมดา และหายากเช่นนี้ ถือเป็นอัญมณีสำหรับนักสะสมตัวจริง
  
  Royal Salute 55 Year Old แต่ละขวดถือเป็นผลงานชิ้นเอกที่ทำจากคริสตัลเป่าด้วยมือ โดยช่างฝีมือผู้ชำนาญ มีหมายเลขกำกับแต่ละขวด โดยบรรจุในกล่องไม้โอ๊คหลายชั้นที่สวยงามซึ่งประดิษฐ์อย่างพิถีพิถัน เพื่อสะท้อนถึงฤดูกาลที่เปลี่ยนแปลงของประเทศสกอตแลนด์ การแกะสลักที่ซับซ้อนเชื่อมโยงถึงแก่นแท้ของพืชและสัตว์ในท้องถิ่น นับเป็นการยกย่องธรรมชาติ งานฝีมือ และประเพณีเหนือกาลเวลาที่อยู่เบื้องหลัง`;
  

  const shortDescription = descriptionText.slice(0, 120) + '...';

    // ✅ ตรวจสอบว่าข้อความเกิน 10 บรรทัดหรือไม่
    useEffect(() => {
      const element = fullTextRef.current;
    
      if (element) {
        requestAnimationFrame(() => {
          const lineHeight = parseFloat(getComputedStyle(element).lineHeight || '10');
          const lineCount = element.scrollHeight / lineHeight;
          setShowToggle(lineCount > 5);
        });
      }
    }, []);
    

  return (
    <div className="container">
      
      <div className='royal'>
      
      <br/>
      <h1>Royal Salute 55 Year Old</h1>

      <div className="image-container">
        <button className="image-nav left" onClick={handlePrevImage}>
          <img src={leftArrow} alt="Previous" />
        </button>
        <img src={productImages[imageIndex]} alt="Product" />
        <button className="image-nav right" onClick={handleNextImage}>
          <img src={rightArrow} alt="Next" />
        </button>
      </div>
      {/* ✅ Description section with toggle */}
      <div className="description">
        <h2>Description</h2>
        <div
          ref={fullTextRef}
          className={isExpanded ? 'expanded' : 'clamped'}
        >
          {descriptionText}
        </div>

        {showToggle && (
          <button onClick={() => setIsExpanded(!isExpanded)} style={{ marginTop: '8px' }}>
            {isExpanded ? 'ย่อข้อความ ▲' : 'อ่านเพิ่มเติม ▼'}
          </button>
        )}
      </div>

      <div className="details">
        <h2>Details</h2>
        <p><strong>Brand:</strong> Royal Salute</p>
        <p><strong>Edition:</strong> xxx</p>
        <p><strong>Country:</strong> Scotland</p>
        <p><strong>Size:</strong> 70cl</p>
        <p><strong>Variental:</strong> Blended Whisky</p>
        <p><strong>Owner:</strong> Artventure</p>
      </div>
      <div className="bottom"> 
        <p className='px'>Cool AR experiences await you!</p>
        <p>Download the app now!</p>
        <div className="store-links">
          <a href="https://play.google.com/store/search?q=artventure&c=apps&hl=th-TH" target="_blank" rel="noopener noreferrer">
            <img src={bt_playstone} alt="Play Store" />
          </a>
          <a href="https://apps.apple.com/th/app/artventurenft/id6472034909?l=th" target="_blank" rel="noopener noreferrer">
            <img src={bt_applesotre} alt="Apple Store" />
          </a>
        </div>
      </div>
      </div>
      <div className="footer">
        <p>copy right 2024 ArtventureNFT Thailand</p>
      </div>
    </div>
  );
};

export default DigitalConfirmRoyalSalute2Component;
